import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaWhatsapp,
} from "react-icons/fa";
import "../../../assets/css/customer/contactUs/ContactUs.css";

const ContactUs = () => {
  const navigate = useNavigate();
  const phoneNumber = "+923338170801"; // update with real number (no spaces, with country code)
  const whatsappNumber = "923338170801"; // update, digits only, no + or leading 0

  return (
    <div className="contact-page">
      {/* ── Back Button ── */}
      <button className="contact-back-btn" onClick={() => navigate(-1)}>
        <FaArrowLeft /> Back
      </button>

      {/* ── Header ── */}
      <div className="contact-header">
        <h1 className="contact-header-title">
          <FaPhoneAlt className="contact-header-icon" />
          Contact Us
        </h1>
        <p className="contact-header-subtitle">
          Need help choosing the perfect furniture? Visit our showroom or
          reach out anytime during business hours.
        </p>
      </div>

      {/* ── Main Content ── */}
      <div className="contact-content">
        {/* Left: Details */}
        <div className="contact-details">
          <div className="contact-card">
            <div className="contact-card-icon">
              <FaMapMarkerAlt />
            </div>
            <div className="contact-card-text">
              <h3>Showroom Address</h3>
              <p>Jandu Road Near Amir General Store, Canal View, Daska</p>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <FaPhoneAlt />
            </div>
            <div className="contact-card-text">
              <h3>Phone Numbers</h3>
              <p>+92 333 8170801 &nbsp;|&nbsp; +92 333 8170801</p>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <FaEnvelope />
            </div>
            <div className="contact-card-text">
              <h3>Email</h3>
              <p>adfurniturehouse347@gmail.com</p>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon">
              <FaClock />
            </div>
            <div className="contact-card-text">
              <h3>Business Hours</h3>
              <p>Mon – Sat: 7:00 AM – 9:00 PM &nbsp;|&nbsp; Fri: Closed</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="contact-cta">
            <a href={`tel:${phoneNumber}`} className="cta-btn cta-btn-solid">
              <FaPhoneAlt /> Call Now
            </a>
            <a
              href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Hi! I'm interested in your furniture. Can you help me?")}`}
              target="_blank"
              rel="noreferrer"
              className="cta-btn cta-btn-whatsapp"
            >
              <FaWhatsapp /> WhatsApp
            </a>
            <a
              href="https://www.google.com/maps?q=Amir+General+Store,+Jandu+road,+Canal+View,+Daska"
              target="_blank"
              rel="noreferrer"
              className="cta-btn cta-btn-outline"
            >
              <FaMapMarkerAlt /> Directions
            </a>
          </div>
        </div>

        {/* Right: Map */}
        <div className="contact-map">
          <iframe
            title="AD Furniture House Showroom Location"
            src="https://www.google.com/maps?q=Amir+General+Store,+Jandu+road,+Canal+View,+Daska&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;